var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClimateShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 335.83 344.34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Climate Shield") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 306.21,
    y1: 172.17,
    y2: 172.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e1de",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbd8d4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cccbc7",
    offset: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a5a7a6",
    offset: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676f71",
    offset: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#465155",
    offset: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868d8f",
    offset: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6b9ba",
    offset: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d4d5d5",
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfdfdf",
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5d6d7",
    offset: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bbbec1",
    offset: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91979d",
    offset: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8a9197",
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d0d1d2",
    offset: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a4a8aa",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 43.5,
    x2: 335.64,
    y1: 133.2,
    y2: 133.2,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -217.72,
    x2: 82.49,
    y1: 11.91,
    y2: 11.91,
    gradientTransform: "translate(98.24 235.44) rotate(177.64)",
    xlinkHref: "#a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "climateShield1CSC",
    transform: "translate(0)",
    d: "M335.06,109.65s-.27,10.61-41.45,28.86l1-14.81s16.28-6.63,18.67-17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "climateShield1CSC",
    transform: "translate(0)",
    d: "m16.77 251.1s1.33-13.1 35.14-31.47l4.84 17.06s-16 7.3-18 17.81"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "climateShield2CSC",
    transform: "translate(0)",
    d: "M304.69,23.46A890.53,890.53,0,0,0,214.33,4.61c-42-6.44-82.06-6.3-128.74,1.48-21.44,3.56-49,8.43-84.07,17.53,0,0-27.5,204.36,151.2,320.72h.76C332.18,228,304.69,23.46,304.69,23.46Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "climateShield1CSC",
    transform: "translate(0)",
    d: "M289.62,37.18a772.39,772.39,0,0,0-81.37-16.36C170.41,15,134.36,15.44,92.3,22.44,73,25.66,48.17,29,16.59,37.18c0,0-24.76,190.8,136.17,287.77h.69C314.39,228,289.62,37.18,289.62,37.18Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "climateShield3CSC",
    transform: "translate(0)",
    d: "M286.48,39.63C252.52,30.82,226.57,27,207,24c-37-5.67-72.19-5.07-113.27,1.76-18.88,3.14-43.12,5.8-74,13.81,0,0-24.19,188.44,133,280.56h.66C310.67,228,286.48,39.63,286.48,39.63Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "climateShield4CSC",
    transform: "translate(0)",
    d: "m275.2 46.54c7.48-0.8-58.38-12.78-64.56-13.73-35.86-5.51-70-5.81-109.91 0.83-18.3 3.05-41.83 8.68-71.73 16.46 0 0-11.85 90.66 36 177.48 0 0-3.86-158.31 210.2-181.04z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m290.14 199.06"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "climateShield5CSC",
    transform: "translate(0)",
    d: "m43.55 179.34c2.39-9.37 16.6-38.31 52-83.66 4-5.18 28.61 11.2 28.61 11.2s56.5-25.52 128.07-32.8c39.32-4 62.32-2 75.76 7.93 2.71 2 7.89 12.88 7.63 20.67a51.8 51.8 0 0 1 -0.15 5.52c-0.69 4.17-1.13 2.8-2.27 2.6-17.58-3.07-67.59-4.39-178.89 50.74l17.74 21.65s6.49 11.11 3.77 11.08c-1.45 0-126.21-3.49-126.21-3.49s-6.72-8.86-6.06-11.44z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "climateShield6CSC",
    transform: "translate(0)",
    d: "M43.58,178.92c2.65-10.43,15.12-54.17,60.1-108.83,1.81-2.21,2.78.23,2.78.23l.43.9,12.42,26.26S175.81,72,247.38,64.67c39.32-4,61.87-1.41,75.76,7.94,10.53,7.07,13.68,31.65,12.43,35-.11.29-.74,0-1,0-16.39-3.89-73.82-10.54-185.12,44.59l21.92,30s2.31,2.76-.42,2.73c-1.44,0-126.2-3.49-126.2-3.49S42.92,181.51,43.58,178.92Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "climateShield7CSC",
    transform: "translate(0)",
    d: "m313.3 167.2c-2.06 9.73-15.43 40-49.88 88.11-3.92 5.49-29.84-10.3-29.84-10.3s-56.93 28.59-130.12 39.11c-40.19 5.77-63.91 4.71-78.12-4.94-2.87-1.95-8.65-12.89-8.71-20.9a54.73 54.73 0 0 1 -0.09 -5.68c0.54-4.3 1-2.92 2.24-2.76 18.17 2.4 69.58 1.65 181.52-59.67l-19.13-21.48s-7.13-11.14-4.33-11.22c1.49 0 129.74-1.75 129.74-1.75s7.28 8.81 6.72 11.48z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "climateShield8CSC",
    transform: "translate(0)",
    d: "M313.29,167.63c-2.29,10.83-13.24,56.26-57.11,114.3-1.77,2.35-2.87-.11-2.87-.11l-.47-.91L239,254.47S182,283.06,108.86,293.57c-40.21,5.78-63.47,4.08-78.13-4.94-11.11-6.81-15.39-31.92-14.24-35.37.09-.31.75-.07,1,0,17,3.3,76.23,7.71,188.18-53.62l-23.77-29.87s-2.49-2.73.32-2.82c1.48-.05,129.74-1.76,129.74-1.76S313.85,165,313.29,167.63Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClimateShield);
export default __webpack_public_path__ + "static/media/climate-shield.91847f7e14462ca3283743c25ca4c2e2.svg";
export { ForwardRef as ReactComponent };